import { render, staticRenderFns } from "./SetUser.vue?vue&type=template&id=7a854752&scoped=true"
import script from "./SetUser.vue?vue&type=script&lang=js"
export * from "./SetUser.vue?vue&type=script&lang=js"
import style0 from "./SetUser.vue?vue&type=style&index=0&id=7a854752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a854752",
  null
  
)

export default component.exports